// simple handlebars template wrapper for fetching a template
// and automatically including the js_lang translations object
(function(hb,translations) {
    template = function(template_name, template_vars, no_render) {
        if (typeof template_vars == 'undefined') {
            template_vars = {js_lang:translations};
        } else if (typeof template_vars == 'object') {
            template_vars.js_lang = translations;
        }

        if (typeof template_name != 'undefined' && typeof hb.templates[template_name] != 'undefined') {
            var hb_template_func = hb.templates[template_name];
            return (no_render === true) ? hb_template_func() : hb_template_func(template_vars);
        }
    };

    //output list of template names (dev friendly helper)
    template.list = function() {
        for (var template_name in hb.templates) {
            if (hb.templates.hasOwnProperty(template_name)) {
                console.log(template_name);
            }
        }
    };

    // handlebar custom helpers
    var helpers = {
        emoji_heart: function(text) {
            if (!text || typeof(text.replace) !== 'function') {
                return text;
            }

            return text
                .replace(/<3/g, '❤️')
                .replace(/&lt;3/g, '❤️');
        },
        decode_unsafe_chars: function(text) {
            // NOTE: ONLY use this when in a div,p, or equivalent element body: <div>{{ OK_HERE }}</div>.
            // NEVER use this in an element attribute: <input value="{{ NEVER_HERE }}" x-init="{{ NEVER_HERE }}">
            // also, do not decode left and right angle brackets (<,>) in this method (or anywhere else)

            if (!text || typeof(text.replace) !== 'function') {
                return text;
            }

            // Decode HTML entities for single and double quotes (and curly quotes)
            text = text
                .replace(/&#039;/g, "'") // Single quote (decimal)
                .replace(/&apos;/g, "'") // Single quote (alternative)
                .replace(/&#x27;/g, "'") // Single quote (hexadecimal)
                .replace(/&quot;/g, '"') // Double quote (decimal)
                .replace(/&#x22;/g, '"') // Double quote (hexadecimal)
                .replace(/&rsquo;|&lsquo;/g, "'") // Single curly quotes
                .replace(/&ldquo;|&rdquo;/g, '"'); // Double curly quotes

            // Decode ampersand
            text = text.replace(/&amp;/g, '&');

            // Decode misc chars that should not have been encoded
            text = text
                .replace(/&hellip;/g, '…'); // Decode horizontal ellipsis

            // Replace non-encoded curly with normal quotes
            text = text
                .replace(/[‘’]/g, "'") // Curly single quotes
                .replace(/[“”]/g, '"'); // Curly double quotes

            return text;
        }
    };

    // register helpers with handlebars framework
    for (var helper_name in helpers) {
        if (helpers.hasOwnProperty(helper_name)) {
            Handlebars.registerHelper(helper_name,helpers[helper_name]);
        }
    }

})(Handlebars,js_lang);
